module.exports = __webpack_public_path__ + "img/people-orange-q.06cb2a1f.png";